import { render, staticRenderFns } from "./NoticeOnBoardLetter.vue?vue&type=template&id=1f235c69"
import script from "./NoticeOnBoardLetter.vue?vue&type=script&lang=js"
export * from "./NoticeOnBoardLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f235c69')) {
      api.createRecord('1f235c69', component.options)
    } else {
      api.reload('1f235c69', component.options)
    }
    module.hot.accept("./NoticeOnBoardLetter.vue?vue&type=template&id=1f235c69", function () {
      api.rerender('1f235c69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TemplateMaintain/NoticeOnBoardLetter.vue"
export default component.exports